<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>고객문의 등록정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">등록자</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.user_name}} {{qaDatas.user_auth_type != null ? (qaDatas.user_auth_type == 'normal' ? '(일반회원)' : '(구독회원)') : ''}}</td>
<!--                    <td width="150" style="background-color:#f1f1f1">-->
<!--                      <label class="col-form-label">회원종류</label>-->
<!--                    </td>-->
<!--                    <td class="" style="vertical-align:middle">-->
<!--                      {{qaDatas.user_auth_type != null ? (qaDatas.user_auth_type == 'normal' ? '일반회원' : '구독회원') : ''}}-->
<!--                    </td>-->
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">등록일</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.reg_date}}</td>
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">문의구분</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.public_type_name}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">문의종류</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.type_name}}</td>
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">이메일</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.reg_user}}</td>
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">핸드폰번호</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.mobile}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">제목</label>
                    </td>
                    <td class="" colspan="3" style="vertical-align:middle">{{qaDatas.title}}</td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">내용</label>
                    </td>
                    <td class="" colspan="3" style="vertical-align:middle"><div v-html="qaDatas.contents"></div></td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>

        <b-card>
          <div slot="header">
            <strong>
              <div>고객문의 답변</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">답변자</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{userInfo.manager_id}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">답변상태</label>
                    </td>
                    <td class="" style="vertical-align:middle">{{qaDatas.qastatus_name}}</td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">제목</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" name="subject" type="text" v-model="queryParams.reply_title" v-validate="'required'" :class="{'is-invalid': errors.has('subject')}"></b-form-input>
                            <span v-show="errors.has('subject')" :class="{error: errors.has('subject')}">제목명은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">답변 템플릿 상태</label>
                    </td>
                    <td class="" style="vertical-align:middle">
                      <select size="0" class="form-control" v-on:change="slotOnChange($event.target.value)">
                        <option value="">템플릿을 선택해주세요.</option>
                        <option v-for="optItem in selectSlotNumbers" :value="optItem.contents" :selected="optItem.template_ord == queryParams.template_ord">
                          {{optItem.template_ord}} - {{optItem.title}}
                        </option>
                      </select>
                    </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">내용</label>
                      </td>
                      <td class="">
                        <vue-ckeditor v-model="queryParams.reply_contents" :config="config" />
<!--                        <textarea id="summernote"></textarea>-->
                      </td>
                  </tr>
                  <tr class="" v-if="qaDatas.public_type_code == 'user'" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">첨부파일<br/>(PDF, IMAGE)</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col md="12" style="padding:13px">
                            <vue-dropzone ref="dropAttachmentFile" id="attachmentFile"
                              :options="dropzoneFileOptions"
                              @vdropzone-file-added="dropzoneAdded"
                              @vdropzone-success="dropzoneVsuccess"
                              @vdropzone-complete="dropzoneAfterComplete"
                              @vdropzone-upload-progress="dropzoneProgress"
                              :duplicateCheck="false">
                              <div class="dropzone-custom-content">
                                <i class="fas fa-cloud-upload-alt fa-3x"></i>
                                <h4 class="dropzone-custom-title mb-0 mt-3">Drag & Drop</h4>
                              </div>
                            </vue-dropzone>
                          </b-col>
                          <b-col md="8" style="margin-top:10px">
                            <draggable class="dragArea attachment"
                                        :options="{animation:300, handle:'.handle'}"
                                        :component-data="getComponentData()">
                                <li class="list-group-item" style="padding:0 0 10px 10px"
                                    v-for="item, index in queryParams.attachmentFileItems"
                                    :key="item.no">
                                    <span class="handle" >
                                        <i class="fa fa-bars fa-lg mt-4"></i>
                                    </span>
                                    <label class="col-form-label">
                                        <!-- <i class="fa fa-2x mt-1 bg-danger" v-bind:class="'fa-file-'+item.file_extensions+'-o'"></i>  -->
                                        {{item.file_originalname}}
                                        <!-- <span>({{item.filesizeStr}})</span> -->
                                        <p class="fileurl" style="display:none">{{item.file_url}}</p>
                                    </label>
                                    <label class="col-form-label" style="float:right; margin:10px 10px 0 0"><a style="cursor:pointer; color:black" v-on:click="removeListFile"><i class="fa fa-remove"></i></a></label>
                                </li>
                            </draggable>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>

                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="3">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="5">
            <div style="float:right; width: 100%">
              <b-row>
                <b-col md="3">
                  <!-- 응대완료, 임시저장 상태고, 비회원의 임시답변이나 회원이 문의한 내용만 삭제  -->
                  <b-button v-if="qaDatas.qastatus != '1' && !(qaDatas.public_type_code == 'public' && qaDatas.qastatus == '2')" variant="danger"
                            style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #f42f2d; font-size:15px"
                            v-on:click="drQaDelete(qaCode)">
                            <h5 style="margin-bottom:0px"><i class="fa fa-remove"></i> 삭제</h5>
                  </b-button>
                </b-col>
                <b-col md="3"><!-- 1:응대대기, 2:응대완료, 3:임시저장 -->
                  <!-- 응대대기,임시저장 상태일 때만 임시저장 가능  -->
                  <b-button v-if="!(qaDatas.public_type_code == 'public' && qaDatas.qastatus == '2')" variant="secondary"
                            style="color:#ffffff; border-radius:5px; width:100%; border:1px solid #248847; font-size:15px"
                            v-on:click="saveDrQa(3)">
                            <h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 임시저장</h5>
                  </b-button>
                </b-col>
                <b-col md="3">
                  <!-- 응대대기,임시저장 상태일 때만 임시저장 가능  -->
                  <b-button v-if="!(qaDatas.public_type_code == 'public' && qaDatas.qastatus == '2')" variant="success"
                            style="color:#ffffff; border-radius:5px; width:100%; border:1px solid #248847; font-size:15px"
                            v-on:click="saveDrQa(2)">
                            <h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="3">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; width:100%; border:1px solid #187c9f; font-size:15px"
                            v-bind:href="'#/customer/qamanager'">
                            <h5 style="margin-bottom:0px"><i class="fa fa-list-ul"></i> 목록</h5>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue';
import datetimepicker from "daterangepicker/daterangepicker.js";
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import draggable from "vuedraggable";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import VueCkeditor from 'vue-ckeditor2';

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    Multiselect,
    draggable,
    vueDropzone: vue2Dropzone,
    VueCkeditor,
  },
  data() {
    return {
      qaCode: '',
      pageOptions: [5, 10, 30, 50, 100],
      formtype: 'insert',
      selectSlotNumbers: [],
      items: [],
      userInfo: {},
      qaDatas: {
        attachmentFileItems:[],
      },
      queryParams: {
        reg_date: moment().format('YYYY-MM-DD'),
        attachmentFileItems:[],
        use_yn: 'Y',
        top_yn: 'N',
        reply_title: '',
        reply_contents:'',
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      isLoading: false,
      enabled: true,
      dropzoneFileOptions: {
          url: 'backend/ftpserver/dropAndSingleFileUpload',
          autoProcessQueue: false,
          params: {
            files: "file",
            reportType: "qamanager",
            fileSubPath: "pdf_or_img",
          },
          thumbnailWidth: 150,
          //maxFilesize: 5.0,
          acceptedFiles: '.pdf,.jpg,.jpeg,.png',
          dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> Drop files here to upload",
      },
      config: {
        toolbar:[
          { name: 'document', items: [ 'Source', 'Preview'] },
          { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
          { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
          '-',
          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
          { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
          { name: 'links', items: ['Link', 'Unlink'] },
          '/',
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: [ 'Maximize' ] },
          { name: 'about', items: [ 'About' ] }
        ],
        font_names: 'Noto Sans KR/Noto Sans KR,sans-serif;맑은 고딕/Malgun Gothic;굴림/Gulim;돋움/Dotum;바탕/Batang;궁서/Gungsuh;',
        filebrowserImageUploadUrl:'backend/ftpserver/ckeditImageUpload',
        uploadUrl: 'backend/ftpserver/ckeditImageUpload?command=QuickUpload&type=Files&responseType=json',
        height: 300,
        versionCheck: false,
        extraPlugins: 'tableresize'
      },
    }
  },
  watch: {
    queryParams: function(value, oldValue){
      console.log(value);
      console.log(oldValue);
    }
  },
  mounted: function() {
    var self = this;
    self.userInfo = self.$session.get('userInfo');
    self.qaCode = self.$session.get('qaCode');
    self.qaPublicTypeCode = self.$session.get('qaPublicTypeCode');

    if(self.qaCode != undefined && self.qaPublicTypeCode != undefined){
      self.getDrQaData();
    }

    self.findQATemplateList();

  },
  methods: {


    // 문의 정보 조회
    getDrQaData() {
      var self = this;
      self.queryParams.id = self.qaCode;
      self.queryParams.public_type_code = self.qaPublicTypeCode;

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/drQaData?access_token=' + token, data, null)
        .then((result) => {
          console.log(result.data);
          // result.data.attachmentFileItems.forEach(function (t_el, t_idx, t_arr){
          //   if(t_el.file_extensions == 'png' || t_el.file_extensions == 'jpg'){
          //     t_el.file_extensions = 'image';
          //   }
          // });

          self.qaDatas = result.data;
          self.queryParams.reply_title = self.qaDatas.reply_title !== '' && self.qaDatas.reply_title !== null ? self.qaDatas.reply_title : "Re: " + self.qaDatas.title;

          if(self.qaDatas.file_url != '' && self.qaDatas.file_url != null){
            self.queryParams.attachmentFileItems = [];
            self.queryParams.attachmentFileItems.push(self.qaDatas);
          }

          if(self.qaDatas.reply_contents != null){
            self.queryParams.reply_contents = self.qaDatas.reply_contents;
            self.formtype = 'update';
          }

          // console.log("formtype",self.formtype);
      });
    },
    // 고객문의 답변 저장 및 수정
    saveDrQa(qastatus) {
      var self = this;

      // 답변메일 로딩 추가
      if (self.isLoading && self.qaPublicTypeCode === 'public'){
        swal.fire({
          type: 'warning',
          title: '답변 메일이 전송중입니다.',
          showConfirmButton: false,
          timer: 1500
        })

        return
      }
      self.isLoading = true;

      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");

          self.queryParams.user_email = self.qaDatas.reg_user;

          self.queryParams.reply_reg_user = self.userInfo.manager_id;
          self.queryParams.type_code = self.qaDatas.type_code;
          self.queryParams.qastatus = qastatus;
          self.queryParams.reply_id = self.qaDatas.reply_id;

          if(self.queryParams.reply_contents == ""){
            swal.fire({
              type: 'warning',
              title: '내용 부분은 필수로 작성해 주세요.',
              showConfirmButton: true,
            })
            return false;
          }

          var urlPath = '';
          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('objs', param);

          if(self.qaPublicTypeCode == 'user' && self.formtype == 'insert'){
            urlPath = '/api/insert/qaReply';
          }else if(self.qaPublicTypeCode == 'user' && self.formtype == 'update'){
            urlPath = '/api/update/qaReply';
          }else if(self.qaPublicTypeCode == 'public' && self.formtype == 'insert'){
            urlPath = '/api/insert/qaPublicReply';
          }else if(self.qaPublicTypeCode == 'public' && self.formtype == 'update'){
            urlPath = '/api/update/qaPublicReply';
          }
          // console.log(self.queryParams);
          self.$http.post(urlPath+'?access_token=' + token, data, null)
              .then((result) => {
                if(result.data > 0){
                  swal.fire({
                    type: 'success',
                    title: '답변을 등록 했습니다.',
                    showConfirmButton: false,
                    timer: 1500
                  }).then(function() {
                    self.isLoading = false;
                    if(qastatus != '3'){
                      window.location = "#/customer/qamanager";
                    }else{
                      self.getDrQaData();
                    }
                  });
                }
            });

          // if(self.formtype == 'insert'){
          //   self.$http.post('/api/insert/qaReply?access_token='+token, data, null)
          //     .then((result) => {
          //       swal.fire({
          //         type: 'success',
          //         title: '공지사항이 등록되었습니다.',
          //         showConfirmButton: false,
          //         timer: 1500
          //       }).then(function() {
          //           window.location = "#/customer/qamanager";
          //       });
          //   })
          // }else if(self.formtype == 'update'){
          //   self.$http.post('/api/update/qaReply?access_token='+token, data, null)
          //     .then((result) => {
          //       swal.fire({
          //         type: 'success',
          //         title: '공지사항을 수정하였습니다.',
          //         showConfirmButton: false,
          //         timer: 1000
          //       }).then(function() {
          //           window.location = "#/customer/qamanager";
          //       });
          //   })
          // }
        }
      })
    },
    /**
    * 이미지 파일 업로드
    */
    uploadSummernoteImageFile(file, editor) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var data = new FormData();
      data.append("file", file);

      self.$http.post('/ftpserver/editorImageUpload?access_token='+token, data, null)
      .then((result) => {
        $(editor).summernote('insertImage', result.data);
      })
    },

    //첨부파일 업로드 후 실행
    dropzoneAfterComplete(file) {
      // console.log(file);
    },
    // 메소드명 : dropzoneAdded()
    // ### 파일 10개 제한 ###
    // 파일이 10개 까지 제한으로 하는 메소드.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    dropzoneAdded (event){
      var self = this;
      setTimeout(function(){
          if(self.queryParams.attachmentFileItems.length >= 1){
            swal.fire({
              title: '파일 최대 업로드!',
              html: "파일은 최대 1개까지 업로드 가능 합니다.",
              type: 'warning',
            })
            self.$refs.dropAttachmentFile.removeAllFiles();
          }else{
            self.$refs.dropAttachmentFile.processQueue();
          }
      }, 100);
    },
    // 메소드명 : dropzoneVsuccess(file, response)
    // ### 드랍존 파일업로드 ###
    // 드랍존 파일다운로드 로서 성공시 이벤트 발생.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - file(현재 파일)
    //  - response(다운로드후 발생하는 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    dropzoneVsuccess(file, response) {
      if(this.queryParams.attachmentFileItems.length == 0){
        response.file_sequence = 1;
        response.file_type_code = 'RPT_FILE_TYPE_1';
      }else{
        response.file_sequence = this.queryParams.attachmentFileItems.length+1;
        response.file_type_code = 'RPT_FILE_TYPE_1';
      }

      if(this.queryParams.attachmentFileItems.length >= 1){
        swal.fire({
          title: '파일 최대 업로드!',
          html: "파일은 최대 1개까지 업로드 가능 합니다.",
          type: 'warning',
        })
        this.$refs.dropAttachmentFile.removeAllFiles();
      }else{
        this.queryParams.attachmentFileItems.push(response);
      }
    },
    // 메소드명 : dropzoneProgress(file, totalBytes, totalBytesSent)
    // ### 드랍존 파일업로드 프로세스 ###
    // 드랍존 파일다운로드 프로세스 진행시 이벤트 발생.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - file(현재 파일)
    //  - totalBytes(총 데이터 용량)
    //  - totalBytesSent(총 보낸 데이터 용량)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    dropzoneProgress(file, totalBytes, totalBytesSent){
      var dropOrg = this.$refs.dropAttachmentFile;
      setTimeout(function(){
          dropOrg.removeAllFiles();
      }, 2500);
    },

// 메소드명 : removeListFile(e)
    // ### 드랍앤드래그 리스트 삭제 ###
    // 드랍앤드래그 삭제시 리스트 순서 정렬과 해당데이터 갱신
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - e(이벤트 발생시)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    removeListFile(e) {
      var fileLists = [];
      var className = e.target.parentNode.parentNode.parentNode.parentNode.classList[1];
      var targetFileUrl = e.target.parentNode.parentNode.parentNode.children[1].lastChild.innerText;
      if(className == "attachment"){
        fileLists = this.queryParams.attachmentFileItems;
      }else if(className == "preview"){
        fileLists = this.queryParams.previewFileItems;
      }

      fileLists.forEach(function (el, idx, arr){
        if(el.file_url == $.trim(targetFileUrl)){
          fileLists.splice(idx, 1);
        }
      });
      fileLists.forEach(function (el, idx, arr){
        el.file_sequence = (idx+1);
      });

      if(className == "attachment"){
        this.queryParams.attachmentFileItems = fileLists;
      }else if(className == "preview"){
        this.queryParams.previewFileItems = fileLists;
      }
    },

    // 메소드명 : handleChange()
    // ### 파일 10개 제한 ###
    // 드래그 드랍 이동시 해당 파일의 순서를 재정렬 한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    handleChange(e) {
      var eventFiles = [];
      if(e.target.classList[1] == "attachment"){
        eventFiles = this.queryParams.attachmentFileItems;
      }else if(e.target.classList[1] == "preview"){
        eventFiles = this.queryParams.previewFileItems;
      }
      var childNode = e.target.childNodes;
      var childNodeLen = e.target.childNodes.length;

      for (var i = 0; i < eventFiles.length; i ++){
        for (var j = 0; j < childNodeLen; j ++){
          var dataFileUrl = childNode[j].children[1].lastChild.innerText;
          if(eventFiles[i].file_url == dataFileUrl){
            eventFiles[i].file_sequence = (j+1);
          }
        }
      }

      if(e.target.classList[1] == "attachment"){
        this.queryParams.attachmentFileItems = eventFiles;
      }else if(e.target.classList[1] == "preview"){
        this.queryParams.previewFileItems = eventFiles;
      }
    },
    inputChanged(value) {
      this.activeNames = value;
    },
    // 메소드명 : getComponentData()
    // ### 드랍앤드래그 리스트 이동 ###
    // 드랍앤드래그 이동시 이벤트 발생.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 : 없음
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
          input: this.inputChanged
        },
        attrs:{
          wrap: true
        },
        props: {
          value: this.activeNames
        }
      };
    },
    // 템플릿 리스트 조회
    findQATemplateList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      self.queryParams.use_yn = 'Y';

      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/qaTemplateList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          var itemCnt = self.items.length;
          self.selectSlotNumbers = [];
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
            el.selectchecked = false;
            if(el.use_yn == 'Y'){
              self.selectSlotNumbers.push(el);
            }
          });

          // setTimeout(() => {
          //   if(self.qaDatas.reply_contents == '' || self.qaDatas.reply_contents == null){
          //     if(self.selectSlotNumbers.length > 0){
          //       $('#summernote').summernote('pasteHTML', self.selectSlotNumbers[0].contents);
          //       self.queryParams.reply_contents = self.selectSlotNumbers[0].contents;
          //     }
          //   }
          // }, 1000);

          // console.log('self.selectSlotNumbers',self.selectSlotNumbers);
          // self.searchData.startday = self.queryParams.start_date;
          // self.searchData.endday = self.queryParams.end_date;
          // self.searchData.dayAllCheck = self.queryParams.day_code == 'dayall';
        })
    },
    slotOnChange(value){
      var self = this;
      //템플릿 선택시
      if(value !== '' && value !== null){
        self.queryParams.reply_contents = value;
      }else{ //선택안하면 기존 내용
        self.queryParams.reply_contents = self.qaDatas.reply_contents;
      }
    },
    drQaDelete(){
      var self = this;

      swal.fire({
        title: '답변 삭제!',
        html: "현재 고객문의의 저장된 답변</br> 모두 삭제 됩니다. 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");

          var urlPath = '';
          self.queryParams.qastatus = 1;
          self.queryParams.reply_id = self.qaDatas.reply_id;

          if(self.qaPublicTypeCode == 'user'){
            urlPath = '/delete/qaReply';
          }else if(self.qaPublicTypeCode == 'public'){
            urlPath = '/delete/qaPublicReply';
          }

          // console.log(self.queryParams);
          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('objs', param);

          self.$http.post('/api'+urlPath+'?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '답변이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                window.location = "#/customer/qamanager";
              });
            })
        }else{
          // cansel
        }
      })
    },
  }
}

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
<style src="daterangepicker/daterangepicker.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/customer/QAManagerForm.vue